<template>
  <div class="turntable">
    <div class="bg">
      <!-- logo -->
      <!-- <div class="logo">
        <img
          :src="imgHost + 'logo.png'"
        />
      </div> -->
      <!-- slogan -->
      <!-- <div class="slogan">
        <img
          :src="imgHost + 'slogan.png?v=1'"
        />
      </div> -->
      <div class="gameCount">您还有{{ gameCount }}次抽奖机会</div>
      <div class="dzp">
        <div
          class="dzpMain"
          :style="{
            transform: rotateAngle,
            transition:
              rotateTransition == ''
                ? 'transform 4s ease-in-out'
                : rotateTransition,
          }"
        >
          <img
            class="dzp_img2"
            :src="imgHost + 'zp.png?v=3'"
            alt
          />
          <div class="prizeList">
            <div
              class="prizeItem"
              :style="{
                transform: `rotate(-${45 * index + 23}deg)`,
              }"
              v-for="(item, index) in myprizeList"
              :key="index"
            >
              <div class="prizeItem-name">{{item.prizeName}}</div>
              <img :src="item.prizeIcon" />
            </div>
          </div>
        </div>
        <img
          class="dzp_Pointer"
          :src="imgHost + 'zz.png?v=3'"
          alt
          @click="clickPointer"
        />
      </div>
    </div>
    <BaseBtnHome></BaseBtnHome>
    <BasePaySuccess></BasePaySuccess>
  </div>
</template>

<script>
import { Indicator, MessageBox } from "mint-ui";
export default {
  components: {},
  props: {},
  data() {
    return {
      rotateAngle: 0, //将要旋转的角度
      startRotatingDegree: 0, //初始旋转角度
      rotateTransition: "transform 0s ease-in-out", //控制过渡效果
      click_flag: true, //是否可以旋转抽奖时禁止点击
      addDeg: 0, //增加度数
      prizeInfo: {}, //中的奖品信息
      // 统计信息接口返回的对象
      count: {
        prizeCount: 0, //中奖人总数
        total: 0, //参与人总数
      },
      isShowFirstDzp: true, // 本活动根据时间又两个大转盘，true 第一个
      todayRemainDrawCount: 2, //今日剩余抽奖次数
      todayRemainDrawCountKey: "",
      prizeModels: [], //奖品配置

      gameCount: 0, //今日剩余抽奖次数
      myprizeList: [], // 奖品列表
      lastCode: 507,
      userList: [],
      gameCount2: 0, // 读语音次数
      animate: false,
      page: "index",
      prizeStatus: 0,
    };
  },
  watch: {},
  filters: {
    filterName: function (name) {
      if (name == null) {
        return name + "***";
      } else if (name && name.length >= 1) {
        return name.slice(0, 2) + "***";
      } else {
        return name + "***";
      }
    },
  },
  computed: {
    
  },
  methods: {
    async clickPointer() {
      this.rotateTransition = "";
      if (!this.click_flag) {
        return;
      }
      this.click_flag = false;
      // 校验大转盘条件
      if (this.gameCount <= 0) {
        this.$modal.drawForm.alert({thanksTxt: '抽奖机会用完了，<br />传播活动还能增加抽奖次数'})
        this.click_flag = true;
      } else {
        //获取奖品
        const data = await this.$httpdf.get(this.apiHost + 'lucky/prize/lottery')
        let prizeInfo = {
            prizeType: data.data,
            turntableOrder: -1,
          };
        if (data.code == 0) {
          let turntableOrder = -1;
          let prizeInfo = {};
          this.myprizeList.map((item, index) => {
            console.log(item, data.data);
            if (item.id == data.data) {
              prizeInfo = {
                ...item,
                turntableOrder: index,
              };
            }
          });
          console.log(turntableOrder);
          this.prizeInfo = prizeInfo;
          this.gameCount -= 1;
          Indicator.close();
          this.turn();
        } else {
          prizeInfo.turntableOrder = -1;
          this.prizeInfo = prizeInfo;
          this.gameCount -= 1;
          Indicator.close();
          this.turn();
        }
      }
    },
    turn() {
      //目前是只转动转盘
      var type = 0; // 默认为 0  转盘转动
      var randCircle = 4; // 附加多转几圈，2-3
      var duringTime = 5; // 默认为 5s
      var rotateAngle1 = 0;
      let tmpAng = 0; // 初始角度
      rotateAngle1 =
        randCircle * 360 + tmpAng + 45 * this.prizeInfo.turntableOrder + 23; //40 大转盘的等分数量
      console.log(rotateAngle1);
      this.addDeg = rotateAngle1;
      if (type == 0) {
        // 转动盘子
        var rotateAngle2 =
          this.startRotatingDegree +
          rotateAngle1 -
          (this.startRotatingDegree % 360); //将要旋转的角度
        this.startRotatingDegree = rotateAngle2; //改变初始旋转的角度
        this.rotateAngle = "rotate(" + rotateAngle2 + "deg)"; //真正控制转动角度
        // 旋转结束后允许再次触发
        setTimeout(() => {
          this.click_flag = true;
          this.turnOver();
        }, duringTime * 1000);
      }
    },
    // 转盘转完
    turnOver() {
      if (this.prizeInfo) {
        console.log(this.prizeInfo);
        if (this.prizeInfo.turntableOrder == -1) {
          this.$modal.drawForm.alert({thanksTxt: '我们已经玩出感情了，再来一次，中奖概率会更大'}).then(() => {
            this.click = true;
            this.showToast = true;
            this.getPrize();
          });
        } else {
          this.$modal.drawForm.alert({ prizeId: this.prizeInfo.id }).then(async ()=> {
            await this.getDrawCount()
            this.getPrize()
            this.getPaySuccess()
          })
        }
      }
    },
    //滚动展示支付列表
    async getPaySuccess() {
      const data = await this.$httpdf.get(this.apiHost + 'lucky/prize/luckyUsers')
      if (data.code == 0) {
        this.userList = data.data;
        //滚动展示支付列表
        setInterval(this.scroll, 2000);
      }
    },
    async getPrize () {
      const data = await this.$httpdf.get(this.apiHost + 'lucky/prize/view')
      if (data.code == 0) {
        let prizeList = {
          prizeName: "谢谢参与",
          prizeIcon: this.imgHost + "10.png",
        }
        this.index = ''
        this.myprizeList = data.data
        this.myprizeList.push(prizeList)
      } else {
        MessageBox.alert(data.msg)
      }
    },
    //获取抽奖次数
    async getDrawCount() {
      const data = await this.$httpdf.get(this.apiHost + 'user/gameCount')
      this.gameCount = data.data.gameCount
    },
    scroll() {
      this.animate = true;
      setTimeout(() => {
        this.userList.push(this.userList[0]);
        this.userList.shift();
        this.animate = false;
      }, 1000);
    },
  },
  created() {
    setInterval(this.scroll, 2000); // 开启滚动中奖用户
    this.getDrawCount()
    this.getPrize()
    this.getPaySuccess()
    // this.$audio.bg.play();
    //获取页面的奖品
    this.$wx.shareCallBackFunList.push("share1", async() => {
      await this.$httpdf.post(this.apiHost + 'share/share');
      this.$modal.share.close()
      if (this.gameCount === 0) {
        this.$router.go(-2)
      } else {
        this.getDrawCount()
      }
    });
  },
  mounted() {},
};
</script>
<style>
</style>
<style lang="scss" scoped>
.turntable {
  min-height: 100vh;
  background: #BEDDEA url($imgHost + 'draw_bg.png?v=2') center 0 / 100% no-repeat;
  overflow-x: hidden;
}

.bg {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;

  .logo {
    padding-top: 15px;
    width: $logoWidth;
  }

  .slogan {
    width: 311px;
    position: relative;
    z-index: 2;
    margin-top: 11px;
  }

  .gameCount {
    // position: absolute;
    margin-top: 230px;
    width: 160px;
    // height: 22px;
    // background: rgba(0, 0, 0, 0.25);
    // border-radius: 11px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FD676D;
    line-height: 22px;
    text-align: center;
  }

  .dzp {
    position: relative;
    margin-top: 17px;
    width: 351px;
    height: 351px;
    margin-bottom: 40px;

    .dzpMain {
      position: relative;
      width: 100%;
      height: 100%;
      margin: 0 auto;
    }

    .dzp_img2 {
      position: relative;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }

    .prizeList {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      .prizeItem {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        text-align: center;
        .prizeItem-name {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #E33939;
          width: 60px;
          margin: 40px auto 0;
        }
        &:nth-child(odd) {
          .prizeItem-name {
            color: #fff;
          }
        }
        img {
          width: 55px;
        }
      }
    }

    .dzp_Pointer {
      position: absolute;
      left: 50%;
      top: 45%;
      width: 97px;
      height: 139px;
      transform: translate(-50%,-50%);
    }
  }
}

</style>